<template>
	<div class="downPage">
		<div class='contain'>
			<el-row style='background:transparent;height:100%;display: flex;'>
				<el-col :span='7' style='margin: 0 auto;display: flex;'>
					<div v-show='activeItem === 0' style='height: 555px;margin: 0 auto;'>
						<div class="bg1">
							<el-image :src="require('@/assets/download/yunPCwindow@2x.png')" style='width: 500px;height: 50px;vertical-align: middle;margin: 15px auto;'></el-image>
						</div>
						<div class='text1'>
							<div >
							2亿端游玩家的梦想！无视显卡、CPU、主板、硬盘空间，再低配的电脑只要下
							</div>
							<div>
								载胖哒云游，即可享受高配电脑体验，畅玩海量3A游戏大作
							</div>
						</div>
						<div class="bg2">
							<el-image :src="require('@/assets/download/download_win_text.png')" style='width: 500px;height: 125px;vertical-align: middle;margin: 0 auto;'></el-image>
						</div>

						<!-- windows 立即下载按钮 -->

						<!-- <div class="bg3" @click='downloadPC'>
							<img data-agl-cvt="6" :src="require('@/assets/download/xzbtn@2x.png')guo5233172
							
								style='width: 250px;height: 60px;vertical-align: middle;margin:45px auto 0px auto;'>
						</div> -->

						<div style="display: flex; justify-content: center; margin-top: 45px;">
							<div class="bg3" @click='downloadPC'>
								<img data-agl-cvt="6" :src="require('@/assets/download/img_download_pangda.jpg')" style='width: 250px;height: 69px;vertical-align: middle;margin-right: 20px;'>
							</div>
							<div class="bg3" @click='downloadAiCloudGame'>
								<img data-agl-cvt="6" :src="require('@/assets/download/img_download_ai.jpg')" style='width: 250px;height: 69px;vertical-align: middle;margin-left: 20px;'>
							</div>
   			 			</div>
					</div>
					<div v-show='activeItem === 1' style='height: 555px;margin: 0 auto;'>
						<div class="bg1">
							<el-image :src="require('@/assets/download/yunPCmobile@2x.png')" style='width: 420px;height: 50px; vertical-align: middle; margin: 15px auto;'></el-image>
						</div>
						<div class='text1'>
							
							<div>
								玩游戏前，你无需下载等待，玩游戏时，你拥有高速畅通的网络环境，玩游戏
							</div>
							<div>
								后，你不必担心占有用手机内存，出现内存空间不足的问题
							</div>
						</div>
						<div class="bg2">
							<el-image :src="require('@/assets/download/download_android_text.png')" style='width: 500px;height: 125px;vertical-align: middle;margin: 0 auto;'></el-image>
						</div>
						<div class='qrCode'>
							<!-- <div class="bg">
								<div class="codeBG">
									<div id='androidCode'></div>
								</div>
								<div class="msg">扫码下载APP</div>
							</div> -->
						</div>
					</div>
					<div v-show='activeItem === 2' style='height: 555px;margin: 0 auto;'>
						<div class="bg1">
							<el-image :src="require('@/assets/download/pcIOS@2x.png')" style='width: 420px;height: 50px; vertical-align: middle; margin: 15px auto;'></el-image>
						</div>
						<div class='text1'>
							
							<div>
								你的手机就是电脑！躺着玩、坐着玩、趴着玩，想
							</div>
							<div>
								怎么玩就怎么玩，没电脑不再是你错过游戏活动的理由
							</div>
						</div>
						<div class="bg2">
							<el-image :src="require('@/assets/download/download_ios_text.png')" style='width: 500px;height: 125px;vertical-align: middle;margin: 0 auto;'></el-image>
						</div>
						<div class='qrCode'>
							<!-- <div class="bg">
								<div class="codeBG">
									<div id='iosCode'></div>
								</div>
								<div class="msg">扫码下载APP</div>
							</div> -->
						</div>
					</div>
					<div v-show='activeItem === 3' style='height: 555px;margin: 0 auto;'>
						<div class="bg1">
							<el-image :src="require('@/assets/download/pcMAC@2x.png')" style='width: 420px;height: 50px; vertical-align: middle; margin: 15px auto;'></el-image>
						</div>
						<div class='text1'>
							
							<div>
								mac不能玩游戏？mac只能画画图？mac只能装装逼？胖哒云游让你的mac变
							</div>
							<div>
								成实力派！windows的游戏想玩就玩，windows的软件想用就用！ 
							</div>
						</div>
						<div class="bg2">
							<el-image :src="require('@/assets/download/download_mac_text.png')" style='width: 500px;height: 125px;vertical-align: middle;margin: 0 auto;'></el-image>
						</div>
						<div class='qrCode'>
							
						</div>
					</div>
					<div v-show='activeItem === 4' style='height: 555px;margin: 0 auto;'>
						<div class="bg1">
							<el-image :src="require('@/assets/download/pcdianshi@2x.png')" style='width: 420px;height: 50px; vertical-align: middle; margin: 15px auto;'></el-image>
						</div>
						<div class='text1'>
							
							<div>
								用电视玩端游体验大屏快乐，360度环绕立体声，家庭影院级享受，超现实沉浸
							</div>
							<div>
								式游戏体验！
							</div>
						</div>
						<div class="bg2">
							<el-image :src="require('@/assets/download/download_dianshi_text.png')" style='width: 500px;height: 125px;vertical-align: middle;margin: 0 auto;'></el-image>
						</div>
						<div class='qrCode'>
							
						</div>
					</div>
					<div v-show='activeItem === 5' style='height: 555px;margin: 0 auto;'>
						<div class="bg1">
							<el-image :src="require('@/assets/download/pcWEB@2x.png')" style='width: 420px;height: 50px; vertical-align: middle; margin: 15px auto;'></el-image>
						</div>
						<div class='text1'>
							
							<div>
								胖哒云游web版，任何人的电脑都能变成你快乐的源泉，不占空间，无需下载，想
							</div>
							<div>
								玩就玩！
							</div>
						</div>
						<div class="bg2">
							<el-image :src="require('@/assets/download/download_wangye_text.png')" style='width: 500px;height: 125px;vertical-align: middle;margin: 0 auto;'></el-image>
						</div>
						<div class='qrCode'>
							
						</div>
					</div>
				</el-col>
			</el-row>
			
			
			<el-row style='background:rgba(0,0,0,1);opacity:0.6;height:140px;display: flex;margin-top: 50px;'>
				<el-col :span='14' style='margin: 0 auto;display: flex;justify-content: center;'>
			<div :class='[activeItem === 0?"btnInfo2":"btnInfo"]' @click='setActive(0)'>
						<el-image v-show='activeItem !=0' :src="require('@/assets/download/Windows_default@2x.png')" 
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<el-image v-show='activeItem ===0' :src="require('@/assets/download/widows_chose@2x.png')"
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<div  :class='[activeItem === 0?"active":"normal"]'>Windows版</div>
					</div>

					<div :class='[activeItem === 1?"btnInfo2":"btnInfo"]' @click='setActive(1)'>
						<el-image v-show='activeItem!=1' :src="require('@/assets/download/android_default@2x.png')"
							style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<el-image v-show='activeItem===1' :src="require('@/assets/download/android_chose@2x.png')"
							style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<div :class='[activeItem === 1?"active":"normal"]' >安卓版</div>
						<div class="tips">
							<div>敬请期待</div>
						</div>
					</div>
					<div :class='[activeItem === 2?"btnInfo2":"btnInfo"]' @click='setActive(2)'>
						<el-image v-show='activeItem!=2' :src="require('@/assets/download/ios_default@2x.png')" 
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<el-image v-show='activeItem===2' :src="require('@/assets/download/ios_chose@2x.png')" 
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<div :class='[activeItem === 2?"active":"normal"]' >iOS版</div>
						<div class="tips">
							<div>敬请期待</div>
						</div>
					</div>
					<div :class='[activeItem === 3?"btnInfo2":"btnInfo"]' @click='setActive(3)'>
						<el-image v-show='activeItem!=3'  :src="require('@/assets/download/mac_default@2x.png')" 
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<el-image v-show='activeItem===3' :src="require('@/assets/download/mac_chose@2x.png')" 
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<div :class='[activeItem === 3?"active":"normal"]' >Mac版</div>
						<div class="tips">
							<div>敬请期待</div>
						</div>
					</div>
					<div :class='[activeItem === 4?"btnInfo2":"btnInfo"]' @click='setActive(4)'>
						<el-image v-show='activeItem!=4' :src="require('@/assets/download/ds_1@2x.png')"  
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<el-image v-show='activeItem===4' :src="require('@/assets/download/ds_2@2x.png')"  
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<div :class='[activeItem === 4?"active":"normal"]' >电视版</div>
						<div class="tips">
							<div>敬请期待</div>
						</div>
					</div>
					<div :class='[activeItem === 5?"btnInfo2":"btnInfo"]' @click='setActive(5)'>
						<el-image v-show='activeItem!=5' :src="require('@/assets/download/wy_1@2x.png')"
						style='width: 25px;height: 25px;vertical-align: middle;margin:60px auto 0 auto;'></el-image>
						<el-image v-show='activeItem===5' :src="require('@/assets/download/wy_2@2x.png')"
						style='width: 25px;height: 25px;vertical-align: middle;margin: 60px auto 0 auto;'></el-image>
						<div :class='[activeItem === 5?"active":"normal"]' >网页版</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<my-footer :copyright="copyright"></my-footer>
	</div>
</template>

<script>
	import axios from 'axios'
	import QRCode from 'qrcodejs2'
	import {mapActions} from 'vuex'
	import MyFooter from '@/components/footer';
	export default{
		name:'downLoad',
		components:{
			MyFooter
		},
		data(){
			return{
				activeItem:0,
				default_url: 'https://dl.tlhcxm.top/PC/pangda/pangdayunyou_pc_official.exe',
				url_list: {},
				pc_url: 'https://dl.tlhcxm.top/PC/pangda/pangdayunyou_pc_official.exe',
				ai_cloudgame_url: 'https://dl.tlhcxm.top/PC/ai/ai_pc_official.exe',
				copyright: ''
			}
		},
		created() {
			this.$utils.checkBrowser();
			const channel = this.$route.query.channel
			if (channel == 'baidu') {
				window._agl = window._agl || [];
				(function () {
					window._agl.push(
						['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
					);
					(function () {
							var agl = document.createElement('script');
							agl.type = 'text/javascript';
							agl.async = true;
							agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
							var s = document.getElementsByTagName('script')[0];
							s.parentNode.insertBefore(agl, s);
					})();
				})();
			}
		},
		methods:{
			...mapActions(['set_is_channel']),
			setActive(index){
				let that = this;
								
				switch(index){
					case 0:
						break;
					case 1:
						that.$utils.Burying({act:'downLoadAndroid',operating_system:'web'});
						break;
					case 2:
						that.$utils.Burying({act:'downLoadIos',operating_system:'web'});
						break;
					case 3:
						that.$utils.Burying({act:'downLoadMac',operating_system:'web'});
						break;
					case 4:
						that.$utils.Burying({act:'downLoadTv',operating_system:'web'});
						break;
					case 5:
						that.$router.push('/game.html');
						that.$bus.$emit('setActiveIndex',1);
					break;
				}
				that.makeDownloadCode(index);
				that.activeItem = index;
				
			},
			downloadPC(){
				let that = this;
				window.location.href = this.pc_url
			},
			downloadAiCloudGame() {
				// 下载 AI 云游戏	
				let that = this;
				window.location.href = this.ai_cloudgame_url
			},
			makeDownloadCode(index){
				let url;
				switch(index){
					case 1:
						// document.querySelector('#androidCode').innerHTML = '';
						// // url = 'http://192.168.1.222:8848/work_Base/official_website/云电脑官网/downloadM.html';
						// url = location.href.replace('download','downloadM') ;
						// var qrcode_1 = new QRCode(document.querySelector('#androidCode'), {
						// 	width: 100,
						// 	height: 100,
						// 	colorDark:"#000000",
						// 	colorLight:"#fff",
						// });
						
						// qrcode_1.makeCode(url);
					break;

					case 2:
						// document.querySelector('#iosCode').innerHTML = '';
						// // url = 'http://192.168.1.222:8848/work_Base/official_website/云电脑官网/downloadM.html';
						// url = location.href.replace('download','downloadM') ;

						// var qrcode_2 = new QRCode(document.querySelector('#iosCode'), {
						// 	width: 100,
						// 	height: 100,
						// 	colorDark:"#000000",
						// 	colorLight:"#fff",
						// });
						
						// qrcode_2.makeCode(url);
					break;
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.downPage{
		margin-top: -15px;
		.contain{
			padding-top: 80px;
			width: 100%;
			height: 100%;
			background: url(../assets/download/downloadBG@2x.png) repeat-x center;
			background-size:cover;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			margin-top: -1px;
			animation: cloud_three 80s linear infinite;
			transform: translate3d(0,0,0);
			
		}
		@-webkit-keyframes cloud_three{
			0%{
				background-position:0 0;
			}
			100%{
				background-position:1200px 0;
			}
		}
		@-moz-keyframes cloud_three{
			0%{
				background-position:0 0;
			}
			100%{
				background-position:1200px 0;
			}
		}
		@keyframes cloud_three{
			0%{
				background-position:0 0;
			}
			100%{
				background-position:1200px 0;
			}
		}
		.contain .bg1{
			width: 100%;
			height: 80px;
			margin-top: 100px;
			display: flex;
		}
		.contain .text1{
			width: 100%;
			height: 80px;
			font-size: 14px;
			font-family: MicrosoftYaHei;
			color: rgba(255,255,255,.8);
			line-height: 40px;
			text-align: center;
		}
		.contain .bg2{
			width: 100%;
			height: 150px;
			display: flex;
		}
		.contain .bg3{
			width: 100%;
			height: 110px;
			display: flex;
			cursor: pointer;
		}
		.contain .qrCode{
			width: 50%;
			display: flex;
			flex-direction: column;
			margin: 0 auto;
		}
		.contain .qrCode .bg{
			background: url(../assets/download/xzCodeBG.png) no-repeat center;
			background-size: 100% 100%;
			width: 116px;
			height: 115px;
			padding: 8px 3px 45px 8px;
			margin: 0 auto;
		}
		.contain .qrCode .msg{
			font-size:16px;
			font-family:MicrosoftYaHei;
			color:rgba(249,221,74,1);
			text-indent: 10px;
			margin-top: 10px;
		}
		.contain .normal{
			color: rgba(159,159,159,1);
			font-size: 18px;
			margin: 5px auto;
			height: 45px;
			line-height: 45px;
			text-align: center;
		}
		.contain .normal:hover{
			color: rgba(159,159,159,1);
		}
		.contain .active{
			font-size: 18px;
			color:rgba(249,221,74,1);
			margin: 5px auto;
			height: 45px;
			line-height: 45px;
			text-align: center;
		}
		
		.foot{
			height:440px;
			background:rgba(13,13,13,1);
			border-top: 2px solid rgba(249,221,74,1);
			/* margin-top: 40px; */
		}
		
		.foot .footInfo{
			width: 70%;
			max-width: 1200px;
			margin:40px auto;
			display: flex;
			justify-content: space-between;
			font-family:MicrosoftYaHei;
			color:rgba(164,164,164,1);
		}
		.foot .footInfo .left{
			text-align: left;
		}
		.foot .footInfo .right{
			font-size: 15px;
			display: flex;
		}
		.foot .footText{
			width: 70%;
			max-width: 1200px;
			height: 100px;
			line-height: 100px;
			margin: 0 auto;
			font-family: MicrosoftYaHei;
			color:#606268;
			text-indent: 250px;
			border-top: 1px solid #606268;
		}
		.tips{
			width:67px;
			height:23px;
			border-radius:96px 96px 96px 0px;
			border:1px solid rgba(249,221,74,1);
			font-size:12px;
			font-family:MicrosoftYaHei;
			color:rgba(249,221,74,1);
			position: relative;
			top: -105px;
			left: 85px;
			margin-bottom: -23px;
		}
		.tips div{
			text-align: center;
			margin-top: 3px;
		}
		.btnInfo{
			width: 160px;
			padding: 0 20px;
			cursor: pointer;
			display: flex;
			flex-direction: column;
		}
		.btnInfo2{
			width: 160px;
			padding: 0 20px;
			cursor: pointer;
			background:linear-gradient(180deg,rgba(13,13,13,0) 0%,rgba(255,228,89,.7) 100%);
			display: flex;
			flex-direction: column;
		}
		.btnInfo:hover{
			background:linear-gradient(180deg,rgba(13,13,13,0) 0%,rgba(255,228,89,.7) 100%);
		}
		@media screen and (max-width: 1280px) {
			html,body{
				height: 100%;
				background: #000;
			}
			.my_footer{
				position: fixed;
				bottom: 0;
			}
		}
		
		/* 下载二维码背景 */
		.codeBG{
			width: 100px;
			height: 100px;
			background-color:#fff;
			padding: 5px;
		}
	}
</style>
